module.exports = __webpack_public_path__ + "static/media/comment-minus.96373d37.svg";